<template>
  <div>
    <div class="lg:hidden advanced-search-container" v-if="!showBackToJobs">
      <label for="keyword" style="position: fixed; top: -100px">Keyword</label>
      <label for="location" style="position: fixed; top: -100px"
        >Location</label
      >
      <div class="lg:hidden">
        <AutoComplete
          :param-prop="paramProp"
          v-if="currentBreakpoint === breakpointSmallerSize" />
      </div>
    </div>

    <div id="jobs" class="cdljn-jobs mt-24px lg:mx-4 xl:mx-10">
      <div class="mt-33px lg:hidden">
        <jobs-breadcrumbs
            :param-prop="paramProp"
            v-if="currentBreakpoint === breakpointSmallerSize" />
      </div>
      <div class="flex mt-6 lg:mt-0 justify-center">
        <jobs-filters
          :param-prop="paramProp"
          :current-breakpoint="currentBreakpoint"
        />
        <jobs-hits
          :class="!isCompletelyLoaded ? 'job-hits-loading' : ''"
          :jobs-per-page="jobsPerPage"
          :param-prop="paramProp"
        />
      </div>
    </div>

    <div
      v-if="!isCompletelyLoaded"
      class="flex fixed left-0 top-0 z-[99999] bg-white w-full h-full"
    >
      <div class="newvs-loading default m-auto" style="transform: scale(1)">
        <div class="effect-1 neweffects"></div>
        <div class="effect-2 neweffects"></div>
        <div class="effect-3 neweffects"></div>
      </div>
    </div>
  </div>
</template>

<script>
import BreakpointMixin from '../mixins/BreakpointMixin';
import { getFacets, mediaQuerySizes } from '../utils';

import AutoComplete from './AutoComplete.vue';
import JobsBreadcrumbs from './JobsBreadcrumbs.vue';
import JobsFilters from './JobsFilters.vue';
import JobsHits from './JobsHits.vue';

export default {
  name: 'JobsWrapper',
  components: {
    JobsBreadcrumbs,
    AutoComplete,
    JobsFilters,
    JobsHits,
  },
  mixins: [BreakpointMixin],
  props: {
    jobsPerPage: {
      type: Number,
      required: true,
    },
    paramProp: {
      default: undefined,
    },
  },
  data() {
    const breakpointRefSize = 'lg';
    return {
      breakpointRefSize,
      breakpointSmallerSize:
        mediaQuerySizes[mediaQuerySizes.indexOf(breakpointRefSize) - 1],
      jobFilters: getFacets(JSON.parse(this.paramProp)),
      showBackToJobs: false,
    };
  },
};
</script>

<style>
#jobs .job-hits-loading {
  min-height: 100vh;
}
</style>
